import { Typography } from '@frontend/design_system'
import { useEffect, useRef } from 'react'
import { cookiesService } from 'utils/cookiesService'
import { ONBOARDING_INCOMPLETE_COOKIE_KEY } from 'constants/cookies'
import { ONBOARDING_BLOCK } from 'texts/onboarding'
import styles from './styles.module.scss'
import { isMigratedUserFlowSelector } from 'redux/login/selectors'
import { useAppSelector } from 'redux/hooks'

const REQUIRED_SECTIONS_COUNT = 6
const REQUIRED_SECTIONS_COUNT_MIGRATED_USER = 7

export const OnboardingBlock = ({
  uncompletedSectionsCount,
}: {
  uncompletedSectionsCount: number
}) => {
  const progressRef = useRef<HTMLDivElement>(null)
  const isMigratedUserFlow = useAppSelector(isMigratedUserFlowSelector)
  const requiredSectionsCount = isMigratedUserFlow
    ? REQUIRED_SECTIONS_COUNT_MIGRATED_USER
    : REQUIRED_SECTIONS_COUNT
  const sectionsRemaining = requiredSectionsCount - uncompletedSectionsCount

  useEffect(() => {
    cookiesService.set(ONBOARDING_INCOMPLETE_COOKIE_KEY, true)
  }, [])

  useEffect(() => {
    if (progressRef.current) {
      const MAX_PERCENT = 100
      const coefficient = MAX_PERCENT / requiredSectionsCount
      progressRef.current.style.width = `${sectionsRemaining * coefficient}%`
    }
  }, [sectionsRemaining])

  return (
    <div className={styles.block} data-testid="onboarding-block">
      <Typography color="grey600" name="body2WMedium">
        {ONBOARDING_BLOCK.TITLE}
      </Typography>
      <Typography color="grey600" name="caption1WRegular">
        {ONBOARDING_BLOCK.STEPS}
      </Typography>
      <div className={styles.steps}>
        <div className={styles.progress} ref={progressRef} />
      </div>
      <Typography color="grey600" name="caption1WRegular">
        {`${sectionsRemaining} ${ONBOARDING_BLOCK.OF} ${requiredSectionsCount}`}
      </Typography>
    </div>
  )
}
